var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("general")))]),
                  _c(
                    "w-list",
                    [
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/friendly-ids/",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "list-ol" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("id-friendly")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        { attrs: { to: "/settings/products/" } },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "box" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("products")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        { attrs: { to: "/settings/mails/" } },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "envelope" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("mails")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        { attrs: { to: "/settings/languages/" } },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "globe-europe" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("languages")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/accounting",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "calculator" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("accounting")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/reminders",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "calendar-day" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("reminders")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/reports",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "chart-line" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("reports")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/ubl",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "file-invoice" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("ubl")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/contacts",
                            dsiabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "id-card" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("contacts")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/bank",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "piggy-bank" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("bank")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/crm",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "comment" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("crm")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/journals",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "book" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(" " + _vm._s(_vm.$ct("journals")) + " "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        {
                          attrs: {
                            to: "/settings/extra-field-names",
                            disabled: !_vm.isAdmin,
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "align-center" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("extra-field-names")) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        { attrs: { to: "/settings/label-layouts" } },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "tags" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("label-layouts")) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item",
                        { attrs: { to: "/settings/notifications" } },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "bell" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("notifications")) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm.isSupport
                        ? _c(
                            "w-list-item",
                            { attrs: { to: "/settings/drawer-links" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [
                                  _c("w-fa", {
                                    attrs: { icon: "external-link-alt" },
                                  }),
                                ],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("drawer-links")) + " "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canEditCompany
                        ? _c(
                            "w-list-item",
                            { attrs: { to: "/settings/company" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "building" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(" " + _vm._s(_vm.$ct("company")) + " "),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canEditUsers
                        ? _c(
                            "w-list-item",
                            { attrs: { to: "/settings/users" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "users" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(" " + _vm._s(_vm.$ct("users")) + " "),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c(
                            "w-list-item",
                            { attrs: { to: "/settings/calendar" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "calendar" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(" " + _vm._s(_vm.$ct("calendar")) + " "),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isOwner
                        ? _c(
                            "w-list-item",
                            { attrs: { to: "/settings/api-keys" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "key" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(" " + _vm._s(_vm.$ct("api-key")) + " "),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c(
                            "w-list-item",
                            { attrs: { to: "/settings/backup" } },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "download" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(" " + _vm._s(_vm.$ct("backup")) + " "),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("small", { staticClass: "latest" }, [
                _vm._v("Latest build: " + _vm._s(_vm.buildTime)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }